// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
export enum QUICK_SEARCH_PRIORITY {
	ISSUES,
	PROJECTS,
	BOARDS,
	FILTERS,
	PLANS,
	RECOMMENDED,
}

export const ISSUE_LIMIT = 5;
export const PROJECT_LIMIT = 3;
export const BOARD_LIMIT = 3;
export const FILTER_LIMIT = 3;
export const PLAN_LIMIT = 3;
